import React from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, Button, LinkProps, ButtonProps } from "@mui/material";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useCmrAuth } from "state/CMRAuth";
import MenuIcon from "@mui/icons-material/Menu";
import "./AppHeader.scss";

interface AppHeaderProps {
    hasMenu?: boolean;
}

const MenuButton = styled(Button)<ButtonProps>(() => ({
    color: "#30302e",
    "@media (max-width: 898px)": {
        padding: "0.5rem",
        fontSize: "0.7rem",
    },
    "&:hover": {
        backgroundColor: "#BE0F66",
        color: "#fff",
    },
}));

const NavItem = styled(Link)<LinkProps>(() => ({
    padding: "1rem",
    color: "#30302e",
    textDecoration: "none",
    borderRadius: "4px",
    display: "block",
    "&:hover": {
        backgroundColor: "#BE0F66",
        borderColor: "#BE0F66",
        BorderStyle: "solid",
        boxShadow: "none",
        color: "#fff",
    },
}));

const Logout = styled(Button)<ButtonProps>(() => ({
    borderColor: "#e6117b",
    borderStyle: "solid",
    borderRadius: "4px",
    borderWidth: "1px",
    color: "#e6117b",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",

    "@media (max-width: 898px)": {
        padding: "0.5rem",
        fontSize: "0.7rem",
    },

    "&:hover": {
        color: "#fff",
        backgroundColor: "#e6117b",
    },
}));

const toggleNavigation = () => {
    document.querySelector(".category-list")?.classList.toggle("open");
};

const AppHeader: React.FC<AppHeaderProps> = ({ hasMenu = false }) => {
    const cmrAuth = useCmrAuth();

    const history = useHistory();

    const handleLogOff = () => {
        cmrAuth.signOut();
    };

    const links = [
        {
            url: "/new-setup",
            label: "New Setup",
        },
        {
            url: "/",
            label: "My Setups",
        },
        {
            url: "/category",
            label: "Community Setups",
        },
        {
            url: "/import",
            label: "Import Setup",
        },
    ];

    return (
        <header className="banner">
            <div>
                {hasMenu && (
                    <MenuButton onClick={() => toggleNavigation()}>
                        <MenuIcon />
                    </MenuButton>
                )}
            </div>
            <ul>
                {links.map((link) => (
                    <li key={link.url}>
                        <NavItem
                            key={link.url}
                            color="inherit"
                            onClick={() => history.push(link.url)}
                            sx={{ cursor: "pointer" }}
                        >
                            {link.label}
                        </NavItem>
                    </li>
                ))}
            </ul>

            <Logout onClick={handleLogOff} startIcon={<LogoutIcon />}>
                Log Off
            </Logout>
        </header>
    );
};

export default AppHeader;
